import React from "react";
import { toast } from "react-toastify";
import { withQuery } from "with-query";

import fetchSingleton from "@/lib/fetchSingleton";
import { submitRunner } from "@/lib/formValidationHelpers";
import { useAuth } from "@/lib/useAuth";

export function useValidateAddress<T>(options: {
  submitRunner: submitRunner<T>;
  isEditing?: boolean;
  editingId?: string;
}) {
  const { submitRunner, isEditing, editingId } = options;
  const [isValidateRunning, setIsValidateRunning] = React.useState<boolean>(false);
  const { idToken } = useAuth();

  const startValidate = React.useCallback(async () => {
    if (isValidateRunning) return;

    setIsValidateRunning(true);

    await submitRunner(async (data, handleApiResult) => {
      let url = process.env.NEXT_PUBLIC_API_URL as string;
      url += "/api/v1/address/validate";
      if (isEditing) url = withQuery(url, { address_id: editingId });

      const result = await fetchSingleton(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
        noSideEffects: true,
      });

      handleApiResult(result);

      toast.success("Address Valid", { autoClose: 5000 });
    });

    setIsValidateRunning(false);
  }, [isValidateRunning, editingId, isEditing, submitRunner]);

  return React.useMemo(
    () => ({
      startValidate,
      isValidateRunning,
    }),
    [startValidate, isValidateRunning],
  );
}
